<div class="btn-group-vertical" style="background-color: white; border-radius: 6px;">
  <a (click)="addModelToScene()" class="btn btn-outline-success">
    <i class="fas fa-plus"></i>
    Add To Scene
  </a>
  @if (canEditModel) {
    <a (click)="openModelEditor()" class="btn btn-outline-primary">
      <i class="fas fa-edit"></i>
      Open in Editor
    </a>
  }
</div>